export default __webpack_public_path__ + "static/media/ic_stat2.c32316e3.svg";